/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit EditAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaButtonWithText from 'DesignSystem/TysiaButtonWithText/index'



/** @type {import('Simple/types.js').View} */
export default function EditAction({
  children,
  viewPath = "/App/Account/Content/Settings/Content/CommsEmail/Emails/Emails/Content/Email/Edit/Content/EditAction",
  onSubmit,
  isSubmitting
  
}) {
let editEmailSubmitData = fromData.useDataSubmit({ viewPath,
context: 'edit_email',
})
let editEmailIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'edit_email',
})
  return (<React.Fragment
>
<TysiaButtonWithText
  viewPath={`${viewPath}/TysiaButtonWithText`}
 type="critical"
 data="edit_email"
 onClick={editEmailSubmitData}
 disabled={editEmailIsSubmittingData}
 text="Edit"
/>
{children}
</React.Fragment>)
}